/**
 * Mirror of the Postgres `slugify()` function in
 * shared/migrations/38_slug_triggers.sql:11-21.
 *
 * Lowercase → NFD unaccent → spaces to hyphens → strip non [a-z0-9-] →
 * collapse runs of hyphens → trim leading/trailing hyphens.
 *
 * The server re-runs the Postgres function on POST /slugs to guarantee
 * parity; this helper is only for the live preview as editors type.
 */
export function slugify(input: string): string {
  if (!input) return ''
  return input
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}
